import { render, staticRenderFns } from "./NavigationMenuForPC.vue?vue&type=template&id=4549f9ec&scoped=true&"
import script from "./NavigationMenuForPC.vue?vue&type=script&lang=js&"
export * from "./NavigationMenuForPC.vue?vue&type=script&lang=js&"
import style0 from "./NavigationMenuForPC.vue?vue&type=style&index=0&id=4549f9ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4549f9ec",
  null
  
)

export default component.exports